import {Inject, Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {plainToClass} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {Badge} from 'shared/models/badges/badge';
import {BadgeType} from 'shared/models/badges/badge-type';
import {BadgeTypeFactoryService} from 'shared/badges/services/badge-type-factory.service';
import {BadgesOverviewHttpRepository} from '../repositories/badges-overview.repository.http';
import {IBadgesOverviewRepository} from '../repositories/badges-overview.repository.interface';

@Injectable()
export class BadgesOverviewService {

  constructor(@Inject('IBadgesOverviewRepository') private badgesOverviewRepository: BadgesOverviewHttpRepository,
              private badgeTypeFactoryService: BadgeTypeFactoryService) { }

  public getBadges(): Observable<Array<Badge>> {
    return this.badgesOverviewRepository.getBadges()
      .map((badges: Array<Badge>) => {
        return this.mapToBadges(badges);
      });
  }

  public deleteBadge(id: string): Observable<void> {
    return this.badgesOverviewRepository.deleteBadge(id);
  }

  private mapToBadges(badges: Array<Badge>): Array<Badge> {
    return badges.map((badge: Badge) => {
      const badgeType: BadgeType = this.badgeTypeFactoryService
        .createBadgeType(badge.type.name, badge.type);
      badge.type = badgeType;

      return badge;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-overview/services/badges-overview.service.ts